export default {
    name: 'header',
    component() {
        return {
            open: false,

            init() {
                setTimeout(() => {
                    document.querySelectorAll("[data-menu-vid]").forEach((vid) => {
                        vid.currentTime = 0;
                        vid.pause();                
                    })
                }, 100);
            },

            playScribble() {
                let vid = this.$el.querySelector("video");
                vid.currentTime = 0;
                vid.play();
            },

            stopScribble() {
                let vid = this.$el.querySelector("video");
                console.log(vid);
                vid.currentTime = 0;
                vid.pause();
            }
        }
    }
}